import posthog from "posthog-js";

type EventType =
  | "click"
  | "subscribe"
  | "unsubscribe"
  | "signup"
  | "login"
  | "intercom_click"
  | "auth_error"
  | "attempted_email_login";

type EventCategory = "billing" | "Button Clicks" | "account" | "feedback";

interface ReportEventOptions {
  event_label: string;
  event_category?: EventCategory;
}

function reportEvent(
  event_type: EventType,
  { event_label, event_category }: ReportEventOptions,
) {
  if (typeof window !== "undefined" && window.gtag) {
    try {
      window.gtag("event", event_type, {
        event_category,
        event_label,
      });
    } catch {
      // Silently handle gtag errors (likely due to ad blockers)
    }
  }

  if (typeof window !== "undefined" && posthog) {
    posthog.capture(event_type, {
      event_category,
      event_label,
    });
  }
}

export function reportClick(
  event_label: string,
  event_category: EventCategory = "Button Clicks",
) {
  reportEvent("click", { event_label, event_category });
}

export function reportSubscribe(event_label: string) {
  reportEvent("subscribe", { event_label, event_category: "billing" });
}

export function reportUnsubscribe(event_label: string) {
  reportEvent("unsubscribe", { event_label, event_category: "billing" });
  posthog.capture("downgrade_plan");
}

export function reportIntercomClick(event_label: string) {
  reportEvent("intercom_click", { event_label, event_category: "feedback" });
}

export function reportLogin(event_label: string) {
  reportEvent("login", { event_label, event_category: "account" });

  // we want to report it to the marketing site as well
  if (typeof window !== "undefined" && window.gtag) {
    try {
      window.gtag("event", "login", {
        event_category: "account",
        event_label,
        send_to: process.env.NEXT_PUBLIC_MARKETING_SITE_ID,
      });
    } catch {
      // Silently handle gtag errors (likely due to ad blockers)
    }
  }
}

export function reportSignup(event_label: string) {
  reportEvent("signup", { event_label, event_category: "account" });
  // we want to report it to the marketing site as well
  if (typeof window !== "undefined" && window.gtag) {
    try {
      window.gtag("event", "signup", {
        event_category: "account",
        event_label,
        send_to: process.env.NEXT_PUBLIC_MARKETING_SITE_GTM,
      });
    } catch {
      // Silently handle gtag errors (likely due to ad blockers)
    }
  }
}

export function reportAttemptedEmailLogin(event_label: string) {
  reportEvent("attempted_email_login", {
    event_label,
    event_category: "account",
  });
}

export function reportAuthError(event_label: string) {
  reportEvent("auth_error", { event_label, event_category: "account" });
}
